export enum PaymentType {
    ItauTransfer = 1,
    OP = 2,
    TED = 3,
    BankDraft = 4,
    PIX = 5
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/PaymentType.ts